<template>
  <el-drawer :title="isedit ? '编辑路段' : '新增路段'" :visible.sync="childdialogshow" :show-close="false"
    :destroy-on-close="true" :wrapperClosable="false" direction="rtl" ref="drawer" :size="getViewWidth()"
    :before-close="cancel">
    <div class="dialogshow">
      <div class="dialoForm-content">
        <el-form class="dialoForm-form" ref="createform" :model="createform" label-width="120px" :rules="rules"
          style="width: 95%">
          <el-form-item label="路段名称：" prop="SectionName">
            <el-input v-model="createform.SectionName" maxlength="20" show-word-limit autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="计费规则：" prop="ChargeRuleId">
            <el-select style="width: 100%" v-model="createform.ChargeRuleId" placeholder="请选择计费规则">
              <el-option v-for="item in rulelist" :key="item.Id" :label="item.RuleName" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="小票模板：" prop="TicketId">
            <el-select style="width: 100%" v-model="createform.TicketId" placeholder="请选择小票模板">
              <el-option v-for="item in ticketlist" :key="item.Id" :label="item.TicketName"
                :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务电话：" prop="ServicePhone">
            <el-input v-model="createform.ServicePhone" maxlength="20" show-word-limit autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item> </el-form-item>
          <el-form-item label="路段地址：">
            <el-input v-model="createform.SectionAddress" style="width: 65%"></el-input>
            <el-button style="width: 30%; margin-left: 2.5%; margin-left: 2.5%" type="primary" @click="selectaddress()"
              plain>选择地址</el-button>
          </el-form-item>
          <el-form-item label="启用月卡：">
            <el-switch v-model="createform.MonthCardMark"></el-switch>
            <span v-if="createform.MonthCardMark" style="margin-left: 10px">续费规则：
              <el-select style="width: 240px" v-model="createform.MonthCardRuleId" placeholder="请选择月卡续费规则">
                <el-option v-for="item in monthcardrulelist" :key="item.Id" :label="item.RuleName"
                  :value="item.Id"></el-option> </el-select></span>
          </el-form-item>
          <el-form-item v-if="createform.MonthCardMark" label="月卡共享：">
            <el-switch v-model="createform.ShareMonthCardMark"></el-switch> <span style="margin-left: 10px">共享路段：
              <el-select v-if="createform.ShareMonthCardMark" style="width: 240px" :multiple="true"
                v-model="createform.SectionIds" placeholder="请选择共享月卡的路段">
                <el-option v-for="item in sectionlist" :key="item.Id" :label="item.SectionName"
                  :disabled="item.Id == createform.Id" :value="item.Id"></el-option>
              </el-select></span>
          </el-form-item>
          <!-- <el-form-item v-if="ProductId==2||ProductId==3" label="自动填泊位：">
            <el-switch v-model="createform.AutoInPark" ></el-switch><span
              style="margin-left: 5px;">开启后，车辆入场自动停入空闲泊位，无需选择</span>
          </el-form-item> -->
          <el-form-item v-if="ProductId == 2 || ProductId == 3" label="道闸模式：">
            <el-switch v-model="createform.BarrierGateMark" :change="AutoInParkChange()"></el-switch>
            <div v-if="createform.BarrierGateMark && ProductId == 2"> 计时模式：<el-select style="width: 80%"
                v-model="createform.TimerMode" placeholder="请选择计时模式">
                <el-option label="入场即开始计时" :value="1"></el-option>
                <el-option label="入场不开始计时" :value="2"></el-option>
              </el-select></div>
            <div v-if="createform.BarrierGateMark" style="margin-top: 10px;"> 缴费后<el-input-number
                style="width: 120px;margin-left: 5px; margin-right: 5px;" :min="0" :max="720"
                v-model="createform.OutMinute" controls-position="right"></el-input-number>分钟不离场重新计时,0为不重新计时。</div>
          </el-form-item>
          <el-form-item v-if="createform.BarrierGateMark && ProductId == 3" label="逃单追缴：">
            <el-switch v-model="createform.RecoverMark"></el-switch><span
              style="margin-left: 5px;">开启后，车辆有历史欠费，在出口道闸将进行拦截,补缴后才能出场</span>
            <div v-if="createform.RecoverMark"> 企业编码： <el-input placeholder="逃单验证的企业编码，不输验证本企业" show-password
                v-model="createform.RecoverAccount" style="width: 75%"></el-input>
            </div>
          </el-form-item>
          <el-form-item v-if="createform.BarrierGateMark && ProductId != 1" label="重复入场：">
            <el-switch v-model="createform.RepeatInMark"></el-switch><span
              style="margin-left: 5px;">开启后入口道闸重复入场车辆直接放行</span>

          </el-form-item>
          <el-form-item v-if="createform.RepeatInMark" label="重置时间：">
            <el-switch v-model="createform.RepeatInResetMark"></el-switch><span
              style="margin-left: 5px;">开启后重复入场车辆重置入场时间</span>

          </el-form-item>
          <el-form-item v-if="createform.BarrierGateMark && ProductId != 1" label="无记录放行：">
            <el-switch v-model="createform.NoInPassMark"></el-switch><span
              style="margin-left: 5px;">开启后出口道闸无入场纪录车辆直接放行</span>
          </el-form-item>
          <el-form-item v-if="ProductId == 3" label="一位两车模式：">
            <el-select style="width: 100%" v-model="createform.MCarsType" placeholder="请选择一位两车模式">
              <el-option label="不限制" :value="0"></el-option>
              <el-option label="第二辆以临停车计费" :value="1"></el-option>
              <el-option label="第二辆禁止入场" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input :rows="2" type="textarea" v-model="createform.Remark" maxlength="200" show-word-limit
              autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialoForm-footer">
        <el-button @click="cancel" style="width: 100px">取 消</el-button>
        <el-button style="width: 100px" type="primary" @click="save">保 存</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="mapdialogshow" title="请选择路段位置" :append-to-body="true" :destroy-on-close="true" center
      :width="'650px'">
      <div class="map-address">
        <el-input v-model="input" placeholder="请输入关键词搜索" style="width: 100%;" prefix-icon="el-icon-search"
          class="address-search" @input="searchWithName">
        </el-input>
        <div id="mapDiv"></div>
        <div class="address-list" v-show="addressList && addressList.length">
          <div v-for="(item, index) in addressList" :key="index" @click="selectOneAddr(item.address + item.name)">
            <div>{{ item.address }}</div>
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialogfooter1">
        <el-button @click="mapdialogshow = flase">取 消</el-button>
        <el-button type="primary" @click="submitMap">确 定</el-button>
      </div>
    </el-dialog>
  </el-drawer>
</template>
<style lang='scss' scoped>
.dialogfooter1 {
  text-align: right;
}

.cur {
  cursor: pointer;
}

.map-address {
  height: 60vh;
}

#mapDiv {
  height: 250px;
  position: relative;
}

.address-search {
  width: 20vw;
  z-index: 10000;
  margin-bottom: 10px;
}

.address-list {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  z-index: 10000;
  background-color: #fff;
  padding: 10px;
  min-width: 18vw;
  height: 210px;
  border: 1px solid #DCDFE6;

  >div {
    display: flex;
    align-items: center;
    height: 30px;
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }
  }
}

.address-search .el-input-group__append,
.el-input-group__prepend {
  background-color: #409eff;
  color: #fff;
}
</style>
<script>
import { create, edit, query as querysectionlist } from "@/api/section";
import { query as queryrulelist } from "@/api/rule";
import { query as queryticketlist } from "@/api/ticket";
import { query as querymonthcardrule } from "@/api/monthcardrule";
export default {
  name: "addsection",
  props: {
    isedit: {
      required: true,
      type: Boolean,
    },
    dialogshow: {
      required: true,
      type: Boolean,
    },
    editform: {
      required: true,
      type: Object,
    },
  },
  computed: {
    childdialogshow: {
      get() {
        return this.dialogshow;
      },
      set(val) {
        this.$emit("update:dialogshow", val);
      },
    },
  },
  mounted() {
  },
  created() {
    let that = this;
    if (that.isedit) {
      that.createform = this.editform;
    } else {
      that.createform.MCarsType = 0;
      that.createform.NoInPassMark = false;
      that.createform.RepeatInMark = false;
      that.createform.RepeatInResetMark = false;
    }


    queryrulelist({
      pageSize: 10000,
    }).then((res) => {
      that.rulelist = res.data;
    });
    queryticketlist({
      pageSize: 10000,
    }).then((res) => {
      that.ticketlist = res.data;
    });
    querymonthcardrule({
      pageSize: 10000,
    }).then((res) => {
      that.monthcardrulelist = res.data;
    });
    querysectionlist({
      pageSize: 10000,
    }).then((res) => {
      this.sectionlist = res.data;
    });
    this.ProductId = window.localStorage.ProductId;

  },
  data() {
    return {
      sectionlist: [],
      rulelist: [],
      ticketlist: [],
      monthcardrulelist: [],
      createform: {
        Id: 0,
        SectionName: "",
        ChargeRuleId: "",
        TicketId: "",
        ServicePhone: "",
        Remark: "",
        MonthCardMark: false,
        MonthCardRuleId: "",
        CreateTime: "2022-08-05T09:37:15.206Z",
        CreateUserId: 0,
        AutoInPark: true,
        TimerMode: 1,
        NoInPassMark: false,
        RepeatInMark: false
      },
      ProductId: 1,
      mapdialogshow: false,
      lng: 0,
      lat: 0,
      address: "",
      marker: {},
      input: "",
      map: {},
      addressList: [],
      rules: {
        SectionName: [
          { required: true, message: "路段名称不能为空", trigger: "blur" },
          {
            max: 20,
            message: "路段名称长度不超过20个字，请重新输入",
            trigger: "blur",
          },
        ],
        ServicePhone: [
          { required: true, message: "服务电话不能为空", trigger: "blur" },
          {
            max: 20,
            message: "服务电话长度不超过12个字，请重新输入",
            trigger: "blur",
          },
        ],
        ChargeRuleId: [
          { required: true, message: "请选择计费类型", trigger: "change" },
        ],
        TicketId: [
          { required: true, message: "请选择计费类型", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    input(val) {
      if (!val) {
        this.addressList = [];
        // 用来清空删除太快时候出现列表的bug
        setTimeout(() => {
          this.addressList = [];
        }, 3000);
      }
    },
  },
  methods: {
    AutoInParkChange() {
      if (this.createform.BarrierGateMark) {
        this.createform.AutoInPark = true;
      }
    },
    // 搜索 天地图LocalSearch
    searchWithName(val) {
      if (val) {
        let that = this;
        var config = {
          pageCapacity: 7, //每页显示的数量
          onSearchComplete: localSearchResult, //接收数据的回调函数
        };
        //创建搜索对象
        let localsearch = new T.LocalSearch(that.map, config);
        localsearch.search(that.input, 1);
        function localSearchResult(result) {
          //清空地图及搜索列表
          clearAll();
          //解析建议词信息
          suggests(result.pois);
        }
        //解析建议词信息
        function suggests(obj) {
          if (obj && obj.length) {
            //建议词提示，如果搜索类型为公交规划建议词或公交站搜索时，返回结果为公交信息的建议词。
            that.addressList = obj;
          }
        }
        //清空地图及搜索列表
        function clearAll() {
          that.map.clearOverLays();
        }
      } else {
        this.addressList = [];
      }
    },
    // 初始化地图
    initMap(lat, lng) {
      if (lat == null) {
        lat = 39.907180;
        lng = 116.391270;
      }
      var map;
      var zoom = 16;
      map = new T.Map("mapDiv", {
        projection: "EPSG:4326",
      });
      map.centerAndZoom(new T.LngLat(lng, lat), zoom);
      this.map = map;
      //创建对象
      let geocode = new T.Geocoder();
      // 鼠标点击逆地理搜索
      map.addEventListener("click", function (e) {
        geocode.getLocation(e.lnglat, searchResult);
      });
      let that = this;
      that.marker = new T.Marker(new T.LngLat(lng, lat)); // 创建点
      if (this.createform.SectionAddress != null && this.createform.SectionAddress != "") {
        //向地图上添加标注
        let label = new T.Label({
          text: this.createform.SectionAddress,
          position: { lng: lng, lat: lat },
          offset: new T.Point(10, -20),
        });
        map.addOverLay(label);
      }
      map.addOverLay(that.marker);
      function searchResult(result) {
        if (result.getStatus() == 0) {
          that.address = result.getAddress();
          let label = new T.Label({
            text: that.address,
            position: that.marker.getLngLat(),
            offset: new T.Point(10, -20),
          });
          map.addOverLay(label);
        } else {
          map.clearOverLays();
          console.log(result.getMsg());
        }
      }
      var cp = new T.CoordinatePickup(map, { callback: getLngLat });
      cp.addEvent();
      function getLngLat(lnglat) {
        map.clearOverLays();
        that.lng = lnglat.lng.toFixed(6);
        that.lat = lnglat.lat.toFixed(6);
        that.marker = new T.Marker(new T.LngLat(that.lng, that.lat)); // 创建点
        map.addOverLay(that.marker);
      }
    },
    selectOneAddr(val) {
      let that = this;
      that.map.clearOverLays();
      //创建对象
      let geocoder = new T.Geocoder();
      geocoder.getPoint(val, searchResult);
      function searchResult(result) {
        if (result.getStatus() == 0) {
          that.map.panTo(result.getLocationPoint(), 16);
          //创建标注对象
          var marker = new T.Marker(result.getLocationPoint());
          //向地图上添加标注
          let label = new T.Label({
            text: val,
            position: result.getLocationPoint(),
            offset: new T.Point(10, -20),
          });
          that.map.addOverLay(label);
          that.map.addOverLay(marker);
          that.address = val;
          that.lng = result.getLocationPoint().lng;
          that.lat = result.getLocationPoint().lat;
        } else {
          this.$message.warning("定位出错请重新选择");
        }
      }
    },
    save() {
      this.$refs.createform.validate((valid) => {
        if (valid) {
          if (!this.isedit) {
            create(this.createform).then((res) => {
              this.$message({
                message: "新增路段成功！",
                type: "success",
              });
              this.childdialogshow = false;
              this.$emit("savecomplete", res);
            });
          } else {
            edit(this.createform).then((res) => {
              this.$message({
                message: "保存成功！",
                type: "success",
              });
              this.childdialogshow = false;
              this.$emit("savecomplete");
            });
          }
        }
      });
    },
    selectaddress() {
      this.showmap(this.createform.Latitude, this.createform.Longitude);
    },
    showmap(lat, lng) {
      this.input = "";
      this.addressList = [];
      this.mapdialogshow = true;
      setTimeout(() => {
        this.address = this.createform.SectionAddress;
        this.lng = this.createform.Longitude;
        this.lat = this.createform.Latitude;
        this.initMap(lat, lng);
      }, 500);
    },
    //地图选点确定
    submitMap() {
      if (this.address === "") {
        this.$message.error("请先选择地址！");
        return;
      }
      this.createform.Longitude = this.lng;
      this.createform.Latitude = this.lat;
      this.createform.SectionAddress = this.address;
      this.mapdialogshow = false;
    },
    cancel() {
      this.$emit("cancelcomplete");
    },
  },
};
</script>